export default __webpack_public_path__ + "static/media/About-us-cloudfactory-nepal.82d5eb32.jpg";